import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
    ViewEncapsulation
} from '@angular/core';
import { GhostButtonComponent } from '../../../button/button.component';
import { MENU_PANEL, MenuPanel } from '../../menu.component';

@Component({
    selector: '[nw-menu-item]',
    templateUrl: './item.component.html',
    styleUrl: './item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.role]': 'role',
        '(click)': 'handleClick($event)'
    },
    imports: [GhostButtonComponent],
    encapsulation: ViewEncapsulation.None
})
export class MenuItemComponent {
    @Input({ transform: booleanAttribute }) disabled: boolean = false;

    public role: string = 'menuitem';
    public menu: MenuPanel = inject(MENU_PANEL);

    public handleClick(event: MouseEvent): void {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        this.menu.close.emit();
    }
}
